import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useContext } from 'react';
import { DivisionContext } from '../App';
import { isValidDivision } from '../constants/divisions';

/**
 * Hook that reads a division from the URL query parameter and saves it to context/localStorage.
 *
 * Usage: Call this hook in any page component that should support division tracking via URL.
 * Example URL: /faqs?division=D3
 *
 * The hook:
 * 1. Reads the 'division' query parameter from the URL
 * 2. Validates it against VALID_DIVISIONS (D1-D5)
 * 3. If valid, saves to DivisionContext (which persists to localStorage)
 */
export function useDivisionFromQuery(): void {
  const [searchParams] = useSearchParams();
  const { setLastDivision } = useContext(DivisionContext);

  const divisionParam = searchParams.get('division');

  useEffect(() => {
    if (divisionParam && isValidDivision(divisionParam)) {
      setLastDivision(divisionParam);
    }
  }, [divisionParam, setLastDivision]);
}
